import { useCallback, useState } from "react";

const useWheelBrandValidation = <T extends Record<string, any>>() => {
  const [errors, setErrors] = useState<Record<string, boolean>>({});

  const setError = useCallback((field: string, index: number, hasError: boolean) => {
    const key = `${field}-${index}`;
    setErrors((prev) => ({
      ...prev,
      [key]: hasError,
    }));
  }, []);

  const getError = useCallback(
    (field: string, index: number): boolean => {
      const key = `${field}-${index}`;
      return errors[key] || false;
    },
    [errors],
  );

  const validateTextField = useCallback(
    (value: string, field: keyof T, index: number) => {
      if ((field === "maker_name" || field === "brand_name") && value.length > 100) {
        setError(String(field), index, true);
        return false;
      }
      setError(String(field), index, false);
      return true;
    },
    [setError],
  );

  const validateNumberField = useCallback(
    (value: string | number, field: keyof T, index: number) => {
      if (String(value).length > 9) {
        setError(String(field), index, true);
        return false;
      }
      setError(String(field), index, false);
      return true;
    },
    [setError],
  );

  const parseNumber = useCallback((value: string): number => {
    const parsed = parseFloat(value.replace(/,/g, ""));
    return Number.isNaN(parsed) ? 0 : Number(parsed);
  }, []);

  const formatInputText = useCallback(
    (text: string): string => text.replace(/[^0-9]/g, "").replace(/^0+(?!$)/, ""),
    [],
  );

  const removeCommas = useCallback((text: string): string => text.replace(/,/g, ""), []);

  return {
    errors,
    setError,
    getError,
    validateTextField,
    validateNumberField,
    parseNumber,
    formatInputText,
    removeCommas,
  };
};

export default useWheelBrandValidation;
